import BelaPage from "../../../components/customOrgs/senzacni/BelaPage";

export default function Bela() {
    return <BelaPage />;
}
